/* eslint-disable @typescript-eslint/naming-convention, @typescript-eslint/no-extraneous-class */
export class AppName {
  static readonly ClubHub = 'ClubHub';
  static readonly SmartrFitIntuitive = 'SmartrFitIntuitive';
  static readonly SmartrFitCriteria = 'SmartrFitCriteria';
}
